










import Vue from "vue";
import { onMounted, ref, onBeforeUnmount } from "@vue/composition-api";
export default Vue.extend({
  setup() {
    const scale = ref(1);

    let script: HTMLScriptElement;

    onMounted(() => {
      /*   const is_small_screen = window.innerHeight < 600;
      if (is_small_screen) {
        scale.value = 0.8;
      } */
      script = document.createElement("script");
      script.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      script.type = "text/javascript";
      document.head.appendChild(script);
    });

    onBeforeUnmount(() => {
      script && document.head.removeChild(script);
    });
    return {
      scale
    };
  }
});
